var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_29567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1004 17.0988V14.9988C17.1004 13.8849 16.6737 12.8166 15.9142 12.029C15.1546 11.2413 14.1245 10.7988 13.0504 10.7988H4.95039C3.87626 10.7988 2.84613 11.2413 2.08661 12.029C1.32709 12.8166 0.900391 13.8849 0.900391 14.9988V17.0988",
    fill: "#6A6A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.90039C11.4853 9.90039 13.5 7.88567 13.5 5.40039C13.5 2.91511 11.4853 0.900391 9 0.900391C6.51472 0.900391 4.5 2.91511 4.5 5.40039C4.5 7.88567 6.51472 9.90039 9 9.90039Z",
    fill: "#6A6A99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_29567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGrey);
export default __webpack_public_path__ + "static/media/userGrey.3a1a740e4dd98cd7960b0d408f602fad.svg";
export { ForwardRef as ReactComponent };